import { DateTime } from 'luxon';

export const isISOTimestampExpired = (isoTimestamp: string): boolean =>
  DateTime.fromISO(isoTimestamp) < DateTime.now();
